import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, Card, Typography, Button, TextField, CircularProgress } from '@mui/material';
import meestLogo from '../../assets/logoNew.svg';
import paymentsLogo from '../../assets/payments.png';

const HomeTestPage = () => {
  const location = useLocation();
  const errorFromState = location.state?.error || null;
  const { parcelNumber } = useParams();
  const [id, setId] = useState(parcelNumber || '');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (event) => {
    setId(event.target.value);
  };

  useEffect(() => {
    if (errorFromState) {
      setError(errorFromState);
    }
  }, [errorFromState]);

  const handleSubmit = async () => {
    if (id) {
      setLoading(true);
      setError(null);
      localStorage.removeItem('paymentClicked');

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/clients/v1/sessions/payment/create`,
          {
            parcelNumber: id,
          }
        );

        if (response.data) {
          const redirectLink = response.data.clientLink || response.data.link;
          console.log(redirectLink, 'redirectLink');
          if (redirectLink) {
            window.location.href = redirectLink;
          } else {
            setError('Не вдалося знайти жодного посилання.');
          }
        }
      } catch (error) {
        if (error.response) {
          const statusCode = error.response.status;
          if (statusCode === 400) {
            setError('Відправлення не знайдено. Перевірте номер.');
          } else if (statusCode === 409) {
            setError('Відправлення наразі не потребує оплати.');
          } else if (statusCode === 503) {
            setError('Виникли технічні проблеми. Спробуйте пізніше.');
          } else if (statusCode === 404) {
            setError('Боргу за посилку не знайдено.');
          } else if (statusCode === 429) {
            setError('Забагато спроб, спробуйте пізніше.');
          }
        }
      } finally {
        setLoading(false);
      }
    } else {
      setError('Введіть номер посилки.');
    }
  };

  return (
    <Box height="100vh" bgcolor="#f5f5f5" display="flex" justifyContent="center" alignItems="center">
      <Box
        sx={{
          width: '460px',
          height: '150px',
          backgroundColor: '#005096',
          position: 'absolute',
          top: 0,
          display: {
            xs: 'none',
            sm: 'block',
          },
        }}
      ></Box>
      <Card sx={{
        width: '420px',
        height: '94%',
        maxHeight: '100vh',
        borderRadius: '15px',
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        overflow: 'hidden',
        zIndex: '100'
      }}>
        <Box display="flex" justifyContent="center" mb={4} mt={2}>
          <img src={meestLogo} alt="Meest Logo" style={{ height: '40px', maxWidth: '100%', objectFit: 'contain' }} />
        </Box>

        <Typography variant="h6" align="center" gutterBottom>
          Введіть номер посилки
        </Typography>
        <TextField
          label="Номер посилки"
          variant="outlined"
          value={id}
          onChange={handleInputChange}
          fullWidth
          sx={{ mb: 2 }}
        />

        {error && (
          <Typography variant="body2" color="error" align="center" gutterBottom sx={{ mb: 2 }}>
            {error}
          </Typography>
        )}
        {/* <Button
          variant="contained"
          fullWidth
          sx={{ backgroundColor: '#0061AF', fontWeight: 700 }}
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Знайти посилку'}
        </Button> */}
        {!error && (
          <Button
            variant="contained"
            fullWidth
            sx={{ backgroundColor: '#0061AF', fontWeight: 700 }}
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} sx={{ color: '#fff' }} /> : 'Знайти посилку'}
          </Button>
        )}
        <Box
          sx={{
            mt: { xs: 4, sm: 2 },
            p: { xs: 1, sm: 2 },
            borderRadius: 1,
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            bgcolor: "#FFFFFF",
            width: '92%'

          }}
        >
          <Typography variant="body1" color="textSecondary" gutterBottom>
            Сплата за допомогою сервісів:
          </Typography>
          <Box display="flex" justifyContent="center" alignItems="center" bgcolor="#F5F6F9" p={2}>
            <img src={paymentsLogo} alt="Portmone" style={{ width: '80%', height: 'auto' }} />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default HomeTestPage;
